import { convertToOrderedList, convertToUnorderedList, convertToCheckList } from './operations';

const slashMenu = {
  'Bulleted List': { icon: 'list', basic: true, shortcut: '-', transform: convertToUnorderedList },
  'Numbered List': { icon: 'numbered-list', shortcut: '1.', basic: true, transform: convertToOrderedList },
  'Check List': { icon: 'check-square', shortcut: '- [ ]', basic: true, transform: convertToCheckList },
};

export default slashMenu;
